(ns quuppa.qsm.planner.subs
  (:require [re-frame.core :as rf]
            [quuppa.re-frame-utils :as rf-utils]
            [day8.re-frame.http-fx]))

(rf/reg-sub ::site-plan-root
  (fn [db _]
    (:site-plan db)))

(rf-utils/reg-recursive-sub ::site-plan [::site-plan-root])

(rf/reg-sub ::node-selected?
  (fn [[_ _node-id]]
    (rf/subscribe [:nav/match :parameters :query :selected]))
  (fn [selected [_ node-id]]
    (= selected node-id)))

;; TODO: pure impl to schema or other cljc namespace?

(rf/reg-sub ::id->parent
  (fn [[_ plan-id]]
    (rf/subscribe [::site-plan plan-id :nodes]))
  (fn [nodes _]
    (reduce (fn [acc [parent-id parent]]
              (reduce (fn [acc child-id]
                        (assoc acc child-id parent-id))
                      acc
                      (:children parent)))
            {}
            nodes)))

(rf/reg-sub ::rectangle-m
            (fn [db _]
              (let [selected-building-id (-> db :quuppa.routing/match :parameters :query :building-id)
                    selected-level-id (-> db :quuppa.routing/match :parameters :query :level-id)
                    selected-background-id (-> db :quuppa.routing/match :parameters :query :background-id)
                    site-plan-id (or (-> db :quuppa.routing/match :parameters :path :plan-id) :new)]
                (get-in db [:site-plan site-plan-id :imdf :venue :buildings selected-building-id :levels selected-level-id :siteresource-backgroundimages selected-background-id :rectangleM]))))


(rf/reg-sub ::pixels-per-meter
  (fn [db _]
    (let [selected-building-id (-> db :quuppa.routing/match :parameters :query :building-id)
          selected-level-id (-> db :quuppa.routing/match :parameters :query :level-id)
          selected-background-id (-> db :quuppa.routing/match :parameters :query :background-id)
          site-plan-id (or (-> db :quuppa.routing/match :parameters :path :plan-id) :new)]
      (get-in db [:site-plan site-plan-id :imdf :venue :buildings selected-building-id :levels selected-level-id :siteresource-backgroundimages selected-background-id :ppx]))))

(rf/reg-sub ::display-scale
            (fn [db _]
              (let [selected-building-id (-> db :quuppa.routing/match :parameters :query :building-id)
                    selected-level-id (-> db :quuppa.routing/match :parameters :query :level-id)
                    selected-background-id (-> db :quuppa.routing/match :parameters :query :background-id)
                    site-plan-id (or (-> db :quuppa.routing/match :parameters :path :plan-id) :new)]
                (get-in db [:site-plan site-plan-id :imdf :venue :buildings selected-building-id :levels selected-level-id :siteresource-backgroundimages selected-background-id :scale]))))


(rf/reg-sub ::find-parent-by-type
  (fn [[_ plan-id _ _]]
    [(rf/subscribe [::site-plan plan-id :nodes])
     (rf/subscribe [::id->parent plan-id])])
  (fn [[nodes id->parent] [_ _plan-id node-id node-type]]
    (loop [node-id node-id]
      (when node-id
        (let [node (get nodes node-id)]
          (if (= node-type (:type node))
            (assoc node :id node-id)
            (recur (id->parent node-id))))))))

(rf/reg-sub ::find-children-by-type
  (fn [[_ plan-id _ _]]
    (rf/subscribe [::site-plan plan-id :nodes]))
  (fn [nodes [_ _plan-id node-id node-type]]
    (letfn [(get-children [node-id]
              (let [node (get nodes node-id)]
                (if (= node-type (:type node))
                  ;; Currently only "Node" node can contain more of the same type as children,
                  ;; but currently we aren't interested in those, so we can just stop when
                  ;; matching node is found and ignore its children.
                  [(assoc node :id node-id)]
                  (mapcat get-children (:children node)))))]
      (get-children node-id))))

(rf/reg-sub ::level-background-images
            (fn [db [_ plan-id building-id level-id]]
              (sort-by (comp #(or (:sort-order %) 0) second)
                       (get-in db [:site-plan plan-id :imdf :venue :buildings building-id
                                   :levels level-id :siteresource-backgroundimages]))))
